// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N7J9","option":"styles_option__2L9J1","selected":"styles_selected__21Zt0"};